<template>
  <div class="invite-search-dia" :class="[packageName]">
    <van-dialog v-model="showDia" :showConfirmButton="false" closeOnClickOverlay="false" @close="close" :lock-scroll="false">
      <div class="dialog" v-if="hostDate">
        <div class="avatar-name">
          <img class="avatar" :src="hostDate.avatar | imgPath" alt="" />
          <div class="name-id">
            <span class="name">{{ hostDate.nickname }}</span>
            <div class="id">
              <img src="@/assets/packageAssets/views/P2_Page/Invite/vava/id_icon.png" alt="" />
              {{ hostDate.presentId }}
            </div>
          </div>
        </div>
        <div class="title">{{ hostDate.title }}</div>
        <div class="content">
          {{ hostDate.content }}
        </div>
        <div class="btns">
          <div @click="handleRemove" class="btn btn1" v-if="hostDate.removable">Remove</div>
          <div @click="handleOk" class="btn">OK</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
// 邀请搜索弹框
export default {
  props: {
    showDia: {
      type: Boolean,
      default: false
    },
    title: {},
    headline: {},
    oneShow: {
      type: Boolean,
      default: false
    },
    hostDate: {}
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    handleOk() {
      this.$parent.closeSearchDia()
    },
    close() {
      this.$parent.closeSearchDia()
    },

    // 移除代理下的主播
    handleRemove() {
      this.$parent.removeBtn()
    }
  }
}
</script>

<style lang="scss" scoped>
.invite-search-dia {
  .dialog {
    width: 300px;
    margin: 0 auto;
    padding: 14px 16px 30px;
    background: #ffffff;
    border-radius: 12px;
    font-family: Inter-Regular;
    .avatar-name {
      display: flex;
      align-items: center;
      .avatar {
        width: 46px;
        height: 46px;

        object-fit: cover;
        border-radius: 50%;
      }
      .name-id {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .name {
          width: 150px;
          padding: 0 13px;
          font-size: 17px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .id {
          display: flex;
          align-items: center;
          margin-top: 4px;
          padding: 0 10px;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
          > img {
            width: 30px;
            height: 16px;
            padding: 0 3px;
          }
        }
      }
    }
    .title {
      margin: 26px 0 16px 0;
      font-weight: bold;
      font-size: 16px;
      color: #333333;
      line-height: 26px;
      text-align: left;
    }
    .content {
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      text-align: left;
    }
    .btns {
      display: flex;
      justify-content: space-around;
    }
    .btn {
      width: 240px;
      height: 40px;
      margin: 24px 10px 0;
      background: #a338fc;
      border-radius: 20px;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      font-style: normal;
      border: 1px solid #a338fc;
    }
    .btn1 {
      background: #ffffff;
      color: #a338fc;
      border: 1px solid #a338fc;
    }
  }
}

.invite-search-dia.kiko {
  .dialog {
    width: 300px;
    margin: 0 auto;
    padding: 14px 16px 30px;
    background: #ffffff;
    border-radius: 12px;
    font-family: Inter-Regular;
    .avatar-name {
      display: flex;
      align-items: center;
      .avatar {
        width: 46px;
        height: 46px;

        object-fit: cover;
        border-radius: 50%;
      }
      .name-id {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .name {
          width: 150px;
          padding: 0 13px;
          font-size: 17px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .id {
          display: flex;
          align-items: center;
          margin-top: 4px;
          padding: 0 10px;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
          > img {
            width: 30px;
            height: 16px;
            padding: 0 3px;
          }
        }
      }
    }
    .title {
      margin: 26px 0 16px 0;
      font-weight: bold;
      font-size: 16px;
      color: #333333;
      line-height: 26px;
      text-align: left;
    }
    .content {
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      text-align: left;
    }
    .btns {
      display: flex;
      justify-content: space-around;
    }
    .btn {
      width: 240px;
      height: 40px;
      margin: 24px 10px 0;
      background: #ffe242;
      border-radius: 20px;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      font-style: normal;
      border: 1px solid #ffe242;
    }
    .btn1 {
      background: #ffffff;
      color: #ffe242;
      border: 1px solid #ffe242;
    }
  }
}
</style>
